export function resetKeyInForm() {
    this.$emit('mergeFormData', {
        sn: '',
        remark: ''
    })
}
